import { Endpoint } from '../endpoint';
import { ReportModulesResponse, ReportModuleId, ReportId, ReportPageQuery } from '@business/entities/report';
import { R } from '@core/utils/r';

export function fetchModules() {
  return Endpoint.get<ReportModulesResponse[]>(`@gc/report`);
}

export function fetchReport(moduleId: ReportModuleId, reportId: ReportId, params: ReportPageQuery) {
  params = R.omitBy(params, R.isNil);
  return Endpoint.get<any[]>(`@gc/report/report/${moduleId}.${reportId}`, { params });
}
